import { createItemsList } from "shared/helpers/createItemsList";

const itemsOnPage = [10, 25, 50, 100].map(item => ({
  key: item,
  value: item,
  renderElement: item,
  selectedRenderElement: item,
  active: item === 10,
}));


const levelItems = createItemsList([
  ['BRONCE', 'bronce'],
  ['PLATA', 'plata'],
  ['ORO', 'oro'],
  ['VIP', 'vip'],
]);

const typeItems = createItemsList([
  ['PROMOCODE', 'promocode'],
  // ['REAL', 'real'],
  ['REAL_BALANCE', 'balance'],
  // ['OTHER', 'other'],
]);

const statusItems = createItemsList([
  [true, 'active'],
  [false, 'disable'],
]);

const allowedBonusPromoIds = [4];

const checkBonusPromoAllowed = authData => allowedBonusPromoIds.includes(authData?.id);

const getImageName = url => {
  const arr = url.split('/');
  return arr[arr.length - 1];
}

export {
  itemsOnPage,
  levelItems,
  typeItems,
  statusItems,
  checkBonusPromoAllowed,
  getImageName,
};